import React, { useMemo } from 'react';
import CalendarEventCard from './CalendarEventCard';
import {
  FORTNIGHT_DAYS,
  buildDateRange,
  formatDayHeading,
  getEventsForDay,
  toDateKey,
} from '../../utils/calendarHelpers';

function CalendarListView({ rangeStart, eventsByDate }) {
  const daysWithEvents = useMemo(() => {
    const days = buildDateRange(rangeStart, FORTNIGHT_DAYS);
    return days
      .map((date) => ({
        date,
        dateKey: toDateKey(date),
        events: getEventsForDay(eventsByDate, toDateKey(date)),
      }))
      .filter((d) => d.events.length > 0);
  }, [rangeStart, eventsByDate]);

  if (daysWithEvents.length === 0) {
    return (
      <p className="calendar-list-empty">Ebben az időszakban nincs közzétett program.</p>
    );
  }

  return (
    <div className="calendar-list-view">
      {daysWithEvents.map(({ date, dateKey, events }) => (
        <section key={dateKey} className="calendar-list-day">
          <h3 className="calendar-list-day__title">{formatDayHeading(date)}</h3>
          <div className="calendar-list-day__events">
            {events.map((event) => (
              <CalendarEventCard
                key={event.id || `${dateKey}-${event.time}-${event.title}`}
                event={event}
              />
            ))}
          </div>
        </section>
      ))}
    </div>
  );
}

export default CalendarListView;
